import { render, staticRenderFns } from "./jump-to-section.vue?vue&type=template&id=0a94b47a&scoped=true&"
import script from "./jump-to-section.vue?vue&type=script&lang=js&"
export * from "./jump-to-section.vue?vue&type=script&lang=js&"
import style0 from "./jump-to-section.vue?vue&type=style&index=0&id=0a94b47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94b47a",
  null
  
)

export default component.exports